<template>
    <v-layout
      text-xs-center
      wrap
      pb-3
    >
      <v-flex xs12>
          <h1>Team Tickets</h1>
      </v-flex>
      <v-layout row>
            <v-flex xs3>
              <b>Ticket#</b>
            </v-flex>
            <v-flex xs3>
              <b>English</b>
            </v-flex>
            <v-flex xs3>
              <b>Native</b>
            </v-flex>
            <v-flex xs3>
              <b>Nickname</b>
            </v-flex>
      </v-layout>
      <v-flex xs12 v-for="attendee in team_attendees" :key="attendee.id">
        <v-layout row>
            <v-flex xs3>
              {{ attendee.id }}
            </v-flex>
            <v-flex xs3>
              {{ attendee.full_name }}
            </v-flex>
            <v-flex xs3>
              {{ attendee.native_name }}
            </v-flex>
            <v-flex xs3>
              {{ attendee.nickname }}
            </v-flex>
        </v-layout>
      </v-flex >
      <v-flex xs12 v-if="empty">
        No tickets issued
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: ['team'],
  data: () => ({}),
  beforeMount: async function() {},
  computed: {
    team_attendees() {
      return this.team.tickets;
    },
    empty() {
      return this.team.tickets.length == 0;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style>
</style>
